// extracted by mini-css-extract-plugin
export default {"highlight":"P8RdEdnraLQOPyRl8LfC"};